export default function TrendingSection() {
  const items = [
    { name: 'Air Jordan 4 Retro', category: 'Shoes', avgPrice: '$45-$85', quality: '9.2/10', updated: '2026-06-28' },
    { name: 'Essentials Hoodie', category: 'Hoodies/Sweaters', avgPrice: '$28-$55', quality: '8.8/10', updated: '2026-06-29' },
    { name: 'Vintage Graphic Tee', category: 'T-Shirts', avgPrice: '$12-$25', quality: '8.5/10', updated: '2026-06-29' },
    { name: 'North Face Puffer', category: 'Jackets', avgPrice: '$55-$95', quality: '9.0/10', updated: '2026-06-27' },
    { name: 'Cargo Pants Set', category: 'Pants/Shorts', avgPrice: '$22-$40', quality: '8.6/10', updated: '2026-06-30' },
    { name: 'Leather Crossbody Bag', category: 'Bags', avgPrice: '$30-$60', quality: '8.9/10', updated: '2026-06-28' },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-3">
            Trending Now
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            Trending Spreadsheet Finds This Week
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse min-w-[600px]">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-700 rounded-l-lg">Name</th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-700">Category</th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-700">Avg Price</th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-700">Quality Score</th>
                <th className="text-left py-3 px-4 font-heading font-semibold text-foreground-700 rounded-r-lg">Updated</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i} className="border-b border-background-200/60 hover:bg-background-100 transition-colors">
                  <td className="py-3 px-4 font-medium text-foreground-800">{item.name}</td>
                  <td className="py-3 px-4">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full whitespace-nowrap">
                      {item.category}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-foreground-700">{item.avgPrice}</td>
                  <td className="py-3 px-4">
                    <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                      {item.quality}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-foreground-500 text-xs">{item.updated}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}